import { render, staticRenderFns } from "./EditCreate.vue?vue&type=template&id=6b6eb1e6&scoped=true&"
import script from "./EditCreate.vue?vue&type=script&lang=js&"
export * from "./EditCreate.vue?vue&type=script&lang=js&"
import style0 from "./EditCreate.vue?vue&type=style&index=0&id=6b6eb1e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_webpack@4.46.0_supports-color@7.2.0___css-loader@_7cda17688b6d9c5afadeb45a1beb9a27/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6eb1e6",
  null
  
)

export default component.exports